import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=98794c04&scoped=true"
import script from "./fund.vue?vue&type=script&lang=ts"
export * from "./fund.vue?vue&type=script&lang=ts"
import style0 from "./fund.vue?vue&type=style&index=0&id=98794c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98794c04",
  null
  
)

export default component.exports